const doc = [({"title":({"de":"Sponsoren & Supporter"}), "sections":[]})];
module.exports = doc.length <= 1 ? doc[0] : doc;